import { SiteUtilities } from './utils';
const pricingOffertable = () => {
  SiteUtilities.onModuleLoad('lib/odometer').then(Odometer => Odometer.init());
  const odoPoller = window.setInterval(function () {
    if (typeof window.Odometer !== 'undefined') {
      clearOdoPoller();
      window.Odometer.init();
    }
  }, 500);

  const clearOdoPoller = function () {
    window.clearInterval(odoPoller);
  };
};
export { pricingOffertable } ;
